import { createReducer, on } from '@ngrx/store';
import * as EventsActions from './events.actions';
import { initialEventsState } from './events.state';

export const eventsReducer = createReducer(
  initialEventsState,

  on(EventsActions.loadEvents, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.loadEventsSuccess, (state, { response }) => ({
    ...state,
    events: response.items,
    pagination: {
      total: response.total,
      page: response.page,
      limit: response.limit,
      totalPages: response.totalPages,
    },
    loading: false,
    error: null,
  })),

  on(EventsActions.loadEventsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.loadEventById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.loadEventByIdSuccess, (state, { event }) => {
    const eventExists = state.events.some(e => e.id === event.id);
    return {
      ...state,
      events: eventExists ? state.events.map(e => e.id === event.id ? event : e) : [ ...state.events, event ],
      loading: false,
      error: null,
      selectedEvent: event,
    };
  }),

  on(EventsActions.loadEventByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.createEvent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.createEventSuccess, (state, { event }) => ({
    ...state,
    events: [ ...state.events, event ],
    loading: false,
    error: null,
  })),

  on(EventsActions.createEventFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.updateEvent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.updateEventSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map(e => e.id === event.id ? event : e),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === event.id ? event : state.selectedEvent,
  })),

  on(EventsActions.updateEventFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.deleteEvent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.deleteEventSuccess, (state, { id }) => ({
    ...state,
    events: state.events.filter(e => e.id !== id),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === id ? null : state.selectedEvent,
  })),

  on(EventsActions.deleteEventFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.uploadTitleImage, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.uploadTitleImageSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map(e => e.id === event.id ? event : e),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === event.id ? event : state.selectedEvent,
  })),

  on(EventsActions.uploadTitleImageFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.uploadThumbnail, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.uploadThumbnailSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map(e => e.id === event.id ? event : e),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === event.id ? event : state.selectedEvent,
  })),

  on(EventsActions.uploadThumbnailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.deleteTitleImage, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.deleteTitleImageSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map(e => e.id === event.id ? event : e),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === event.id ? event : state.selectedEvent,
  })),

  on(EventsActions.deleteTitleImageFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.deleteThumbnail, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(EventsActions.deleteThumbnailSuccess, (state, { event }) => ({
    ...state,
    events: state.events.map(e => e.id === event.id ? event : e),
    loading: false,
    error: null,
    selectedEvent: state.selectedEvent?.id === event.id ? event : state.selectedEvent,
  })),

  on(EventsActions.deleteThumbnailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(EventsActions.selectEvent, (state, { event }) => ({
    ...state,
    selectedEvent: event,
  })),
);

